import React from 'react';
import Category from 'components/products/Category';
import { getProductCategory } from 'data/categories';
import { FeatureFlags, useFeaturesGate } from 'util/statsig/index';

export default () => {
  const { value: isRemoveJWMFFOn } = useFeaturesGate(FeatureFlags.CART_STOP_SELLING_JWM);
  const cartProductCategory = getProductCategory(isRemoveJWMFFOn);

  return cartProductCategory.map((category) => (
    <Category key={category.name} name={category.name} products={category.products} />
  ));
};
